import React, { useEffect } from "react";
import { IWMURL } from "../../../redux/config/urlConfig";
import { Dropdown } from "react-materialize";
import Modal from "react-responsive-modal";
import { CloseOrderForm, DeleteOrderForm } from "./CloseOrderModal";
import { useDispatch, useSelector } from "react-redux";
import EditOrder from "./EditOrder";
import {
  deleteOrder,
  getAvailablePickups,
  getOrders,
} from "../../../redux/action/pickups";
import { notify, showAmount, twoDecimals } from "../../../helpers/helper";

function OrderBox({ order, setOrder, selectedOrder }) {
  const { organization } = useSelector((state) => state.organization);
  const [showCloseOrderModal, setShowCloseOrderModal] = React.useState(false);
  const [deleteOrderModal, setShowDeleteOrderModal] = React.useState(false);
  const [showEditOrderModal, setShowEditOrderModal] = React.useState(false);
  const dispatch = useDispatch();

  const pickups = order.pickups?.filter(
    (pickup) =>
      pickup.scraps.some((s) => s._id === order.scrap?._id) ||
      pickup.scrap._id === order.scrap?._id
  );

  const totalQuantity = pickups.reduce(
    (acc, curr) =>
      acc +
      (curr.scraps.find((s) => s._id === order.scrap?._id)?.quantity ||
        curr.quantity),
    0
  );

  return (
    <div
      className={`order-box ${selectedOrder._id === order._id
        ? "order-box-selected green lighten-5"
        : ""
        }`}
      onClick={() => {
        setOrder(order);
        document.getElementById(order._id).scrollIntoView();
      }}
      id={order._id}
    >
      <Modal
        open={showCloseOrderModal}
        onClose={() => setShowCloseOrderModal(false)}
        center
      >
        <CloseOrderForm
          onClose={() => setShowCloseOrderModal(false)}
          onConfirm={() => { }}
        />
      </Modal>
      <Modal
        open={deleteOrderModal}
        onClose={() => setShowDeleteOrderModal(false)}
        center
      >
        <DeleteOrderForm
          onClose={() => setShowDeleteOrderModal(false)}
          onConfirm={() => { }}
        />
      </Modal>

      <Modal
        open={deleteOrderModal}
        onClose={() => setShowDeleteOrderModal(false)}
        center
      >
        <DeleteOrderForm
          onClose={() => setShowDeleteOrderModal(false)}
          onConfirm={() => {
            dispatch(
              deleteOrder(order._id, () => {
                notify("Success!", "Material sourcing announcement deleted.");
                dispatch(getAvailablePickups());
                dispatch(getOrders());
              })
            );
          }}
        />
      </Modal>
      <Modal
        open={showEditOrderModal}
        onClose={() => setShowEditOrderModal(false)}
        center
      >
        <EditOrder onClose={() => setShowEditOrderModal(false)} order={order} />
      </Modal>

      <div className="">
        <div className="flex align-center space-between">
          <div>
            <p
              className={`bold ${selectedOrder._id === order._id ? "green-text" : ""
                }`}
            >
              #{order.orderNumber}
            </p>
            <p className="small-text ">
              {new Date(order.startDate).toDateString()} -
              {new Date(order.endDate).toDateString()}
            </p>

            <p>
              <span>Status: </span>
              {new Date() > new Date(order.endDate) ? (
                <span className="red-text">Expired</span>
              ) : (
                <span className="green-text">Active</span>
              )}
            </p>
          </div>

          <Dropdown
            trigger={<i className="material-symbols-outlined"> more_vert</i>}
          >
            <span
              onClick={() => {
                setShowEditOrderModal(true);
              }}
            >
              Edit
            </span>
            <span
              onClick={() => {
                setShowDeleteOrderModal(true);
              }}
              className="red-text"
            >
              Delete
            </span>
          </Dropdown>
        </div>

        <div className="mt-1 mb-1">
          {order.scraps?.length ? (
            order.scraps?.map((scrap) => {
              const pickups = order.pickups
                .filter(
                  (pickup) =>
                    pickup.scraps.some((s) => s._id === scrap._id) ||
                    pickup.scrap._id === scrap._id
                )
                .filter((pickup) => pickup.accepted);

              const totalQuantity = pickups.reduce(
                (acc, curr) =>
                  acc +
                  (curr.scraps.find((s) => s._id === scrap._id)?.quantity ||
                    curr.quantity),
                0
              );

              // Calculate progress percentage
              const progressWidth =
                scrap.quantity > 0
                  ? Math.min((totalQuantity / scrap.quantity) * 100, 100)
                  : 0;

              return (
                <div
                  className="flex align-start  full-width space-between"
                  style={{
                    borderBottom: "2px solid #f5f5f5",
                    padding: "5px",
                    borderRadius: "5px",
                  }}
                >
                  <div className="flex align-center gap-1 full-width">
                    <img
                      src={`${IWMURL}/scraps/read/image/${scrap._id}`}
                      className="scrap-image mr-1"
                      alt="scrap"
                      style={{ width: "50px", height: "50px" }}
                    />
                    <div>
                      <p className="">
                        {scrap.name}-{scrap.variant}
                      </p>
                      <p>
                        {totalQuantity} {scrap.quantityUnit} / {scrap.quantity} {scrap.quantityUnit}
                      </p>
                      {scrap.price && <p className="small-text grey-text">
                        {scrap.currency} {twoDecimals(scrap.price)}/Kg Expected
                      </p>}
                      <div
                        className="pg-container"
                        style={{
                          width: "100%",
                          background: "#eee",
                          borderRadius: "4px",
                          height: "8px",
                          marginTop: "6px",
                        }}
                      >
                        <div
                          style={{
                            width: `${progressWidth}%`,
                            backgroundColor:
                              selectedOrder._id === order._id
                                ? "green"
                                : "#6f2da8",
                            height: "100%",
                            borderRadius: "4px",
                            transition: "width 0.3s",
                          }}
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="flex align-start  full-width space-between">
              <div className="flex align-center gap-1">
                {" "}
                <img
                  src={`${IWMURL}/scraps/read/image/${order.scrap?._id}`}
                  className="scrap-image mr-1"
                  alt="scrap"
                  style={{ width: "50px", height: "50px" }}
                />
                <div>
                  <p className="">
                    {order.scrap?.name}-{order.scrap?.variant}
                  </p>
                  <p>
                    {totalQuantity}/{order.quantity} Tons
                  </p>
                  <p className="small-text grey-text">
                    {new Date(order.createdAt).toDateString()}
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>

        <div>
          <div className="flex gap-1  ">
            <p>Location: </p>
            <span>
              {
                organization.locations.find((loc) => loc._id === order.location)
                  ?.nickname
              }{" "}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OrderBox;
